import { DD_RUM_APP_ID } from "@/lib/constants";
import { DD_FLAGGING_SITE, resolveFeatureFlagEnv } from "@/lib/openfeature/env";
import { DatadogProvider } from "@datadog/openfeature-browser";
import { OpenFeature } from "@openfeature/react-sdk";

let initialized = false;

export function initOpenFeatureProvider(): void {
  if (initialized || !process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN) {
    return;
  }
  initialized = true;

  const provider = new DatadogProvider({
    applicationId: DD_RUM_APP_ID,
    clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
    site: DD_FLAGGING_SITE,
    env: resolveFeatureFlagEnv(process.env.NEXT_PUBLIC_DD_ENV),
  });

  OpenFeature.setProvider(provider);
}
